import React, { useEffect } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { dictionary } from '../../../dictionary';

const InvoiceNrPayment = ({
  conversion,
  netPaid1Invoice,
  setNetPaid1Invoice,
  netPaid2Invoice,
  setNetPaid2Invoice,
  netPaidEUR1Invoice,
  setNetPaidEUR1Invoice,
  netPaidEUR2Invoice,
  setNetPaidEUR2Invoice,
  grossPaid1Invoice,
  setGrossPaid1Invoice,
  grossPaid2Invoice,
  setGrossPaid2Invoice,
  grossPaidEUR1Invoice,
  setGrossPaidEUR1Invoice,
  grossPaidEUR2Invoice,
  setGrossPaidEUR2Invoice,
  dateInvoice1,
  setDateInvoice1,
  dateInvoice2,
  setDateInvoice2,
}) => {
  useEffect(() => {
    const conv = parseFloat(conversion) || 0;
    if (conv === 0) return;

    const net1 = parseFloat(netPaid1Invoice) || 0;
    const calcNetEur1 = Number((net1 / conv).toFixed(2));
    const calcGrossPln1 = Number((net1 * 1.23).toFixed(2));
    const calcGrossEur1 = Number((calcNetEur1 * 1.23).toFixed(2));

    if (netPaidEUR1Invoice !== calcNetEur1) setNetPaidEUR1Invoice(calcNetEur1);
    if (grossPaid1Invoice !== calcGrossPln1) setGrossPaid1Invoice(calcGrossPln1);
    if (grossPaidEUR1Invoice !== calcGrossEur1) setGrossPaidEUR1Invoice(calcGrossEur1);

    const net2 = parseFloat(netPaid2Invoice) || 0;
    const calcNetEur2 = Number((net2 / conv).toFixed(2));
    const calcGrossPln2 = Number((net2 * 1.23).toFixed(2));
    const calcGrossEur2 = Number((calcNetEur2 * 1.23).toFixed(2));

    if (netPaidEUR2Invoice !== calcNetEur2) setNetPaidEUR2Invoice(calcNetEur2);
    if (grossPaid2Invoice !== calcGrossPln2) setGrossPaid2Invoice(calcGrossPln2);
    if (grossPaidEUR2Invoice !== calcGrossEur2) setGrossPaidEUR2Invoice(calcGrossEur2);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    netPaid1Invoice,
    netPaid2Invoice,
    conversion,
    setNetPaidEUR1Invoice,
    setGrossPaid1Invoice,
    setGrossPaidEUR1Invoice,
    setNetPaidEUR2Invoice,
    setGrossPaid2Invoice,
    setGrossPaidEUR2Invoice,
  ]);

  return (
    <>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_inv_net_paid_1}</label>
          <InputNumber
            style={{ width: '100%' }}
            mode="currency"
            currency="PLN"
            value={netPaid1Invoice}
            onValueChange={(e) => setNetPaid1Invoice(e.value ?? 0)}
          />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_inv_net_paid_2}</label>
          <InputNumber
            style={{ width: '100%' }}
            mode="currency"
            currency="PLN"
            value={netPaid2Invoice}
            onValueChange={(e) => setNetPaid2Invoice(e.value ?? 0)}
          />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_inv_date1}</label>
          <Calendar
            style={{ width: '100%' }}
            value={dateInvoice1}
            onChange={(e) => setDateInvoice1(e.value)}
            showIcon
            showButtonBar
            placeholder={dictionary.export_dialog_calendar_placeholder}
            dateFormat="dd-mm-yy"
          />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_inv_date2}</label>
          <Calendar
            style={{ width: '100%' }}
            value={dateInvoice2}
            onChange={(e) => setDateInvoice2(e.value)}
            showIcon
            showButtonBar
            placeholder={dictionary.export_dialog_calendar_placeholder}
            dateFormat="dd-mm-yy"
          />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_inv_net_paid__eur_1}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={netPaidEUR1Invoice} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_inv_net_paid_eur_2}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={netPaidEUR2Invoice} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_inv_gross_paid_1}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={grossPaid1Invoice} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_inv_gross_paid_2}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="PLN" readOnly value={grossPaid2Invoice} />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_inv_gross_paid__eur_1}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={grossPaidEUR1Invoice} />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_inv_gross_paid_eur_2}</label>
          <InputNumber style={{ width: '100%' }} mode="currency" currency="EUR" readOnly value={grossPaidEUR2Invoice} />
        </div>
      </div>
    </>
  );
};

export default InvoiceNrPayment;
